
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 14.7071L17.2929 16.1213L12 10.8284L6.70709 16.1213L5.29288 14.7071L12 8L18.7071 14.7071Z" fill="currentColor"></path></svg>';export default svg;
    